module.exports = __webpack_public_path__ + "static/media/home-teepee.8acf9f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-teepee.jpg
// module id = 134
// module chunks = 0